import {styled} from "@mui/material/styles";

export const ContainerButonsEdit = styled('div')(() => {
  return {
    display:'flex',
    flexDirection:'row',
    justifyContent: 'center',
    gap: '0.5rem',
  }
})